// Preview dimensions inferred from the agreed WhatsApp samples, in CSS pixels.
export function mediaFrameSize(kind, width, height) {
  if (kind === "sticker") return { width: 190, height: 190 };
  const valid = Number.isFinite(Number(width)) && Number(width) > 0
    && Number.isFinite(Number(height)) && Number(height) > 0;
  // Reserve a square until metadata is available; never guess an orientation.
  const ratio = valid ? Number(width) / Number(height) : 1;
  const frameWidth = ratio < 1 ? 240 : 330;
  return { width: frameWidth, height: frameWidth / Math.max(0.71, ratio) };
}
